export default {
    development: {
        //网站h5
        searchLink: 'http://zsdy-search-h5.daily.bjzsdy.com/',
        //答疑
        dyLink: 'http://zsdy-zskdy-pc.daily.bjzsdy.com/',
        //zsg
        zsgLink: 'http://zsdy-zsg-pc.daily.bjzsdy.com/',
        //引导式咨询
        ydszxLink: 'http://zsdy-znws-pc.daily.bjzsdy.com/',
        //在线专家咨询
        zxzjzxLink: 'http://zsdy-just-ask-pc.daily.bjzsdy.com/',
        //知识点咨询
        zsdzxLink: 'http://zsdy-zskws-pc.daily.bjzsdy.com/',
        //政策依据确定
        zcyjqdLink: 'http://zsdy-myzc-pc.daily.bjzsdy.com/',
        //相应答疑确定
        xydyqdLink: 'http://zsdy-zskdy-pc.daily.bjzsdy.com/',
        //纳税形式确定
        nsxsqdLink: 'http://zsdy-tax-discount-frontend-pc.bjzsdy.com/nsxs',
        //征收项目确定
        zsxmqdLink: 'http://zsdy-tax-discount-frontend-pc.bjzsdy.com/zsxm',
        //方案更新确定
        fagxqdLink: 'http://zsdy-mytx-pc.daily.bjzsdy.com/',
        // 登录
        loginLink: 'http://passport.bjzsdy.com/?client_id=zsg&redirectUrl=',
        // 登录后个人中心
        loginGr: 'http://zsdy-zsg-pc.shui12366.com/user',

    },
    production: {
        //网站h5
        searchLink: 'http://zsdy-search-h5.shui12366.com/',
        //答疑
        dyLink: 'https://zsdy-zskdy-pc.shui12366.com/',
        //zsg
        zsgLink: 'http://zsdy-zsg-pc.shui12366.com/',
        //引导式咨询
        ydszxLink: 'http://zsdy-znws-pc.bjzsdy.com/',
        //在线专家咨询
        zxzjzxLink: 'http://zsdy-just-ask-pc.bjzsdy.com/',
        //知识点咨询
        zsdzxLink: 'http://zsdy-zskws-pc.bjzsdy.com/',
        //政策依据确定
        zcyjqdLink: 'http://zsdy-myzc-pc.bjzsdy.com/',
        //相应答疑确定
        xydyqdLink: 'http://zsdy-zskdy-pc.bjzsdy.com/',
        //纳税形式确定
        nsxsqdLink: 'http://zsdy-tax-discount-frontend-pc.shui12366.com/nsxs',
        //征收项目确定
        zsxmqdLink: 'http://zsdy-tax-discount-frontend-pc.shui12366.com/zsxm',
        //方案更新确定
        fagxqdLink: 'http://zsdy-mytx-pc.bjzsdy.com/',
        // 登录
        loginLink: 'http://passport.bjzsdy.com/?client_id=zsg&redirectUrl=',
        // 登录后个人中心
        loginGr: 'http://zsdy-zsg-pc.shui12366.com/user',
    },
}